import LozalizationMock from '../static/api/mock/LocalizationMock.js'
export default class Localization {
        static lang = 'pl/PL';
        static keys = {};
        static download () {
          var query = `query  
            {
               Localization(code: "` + Localization.lang + `"){
                keys
               }
            } `
          // console.log(LozalizationMock.get(query))
          Localization.keys = LozalizationMock.get(query)['data']['Localization']['keys']
        }
        static translate (code) {
        //    console.log(Localization.keys)
          //      console.log(code)
          return Localization.keys[code]
        }
}
Localization.download()



// WEBPACK FOOTER //
// ./src/dao/Localization.js